











import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

export default Vue.extend({
  name: 'ConversationDetailLoading',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },
})
